import React from "react";
import styles from "../../pages/logs/components/style.module.css";

export default function Notfound() {
  return (
    <>
      <div className="topbar public error"></div>
      <div className={styles.notfound_page}>
        <div>
          <h1 className={styles.next_error_h1}>404</h1>
          <div className={styles.cus}>
            <h2>This page could not be found.</h2>
          </div>
        </div>
      </div>
    </>
  );
}
